import { Component } from '@angular/core';
import { ApiOpenmindService } from '../apiopenmind.service'
import { SharedDataService } from "../shared-data.service";
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-counter-component',
  templateUrl: './counter.component.html'
})
export class CounterComponent {

  public currentCount = 0;
  public objUser: any;

  constructor(private apiOpenmind: ApiOpenmindService, private sharedData: SharedDataService) {
  }

  ngOnInit() {

    this.sharedData.currentUser.subscribe(message => this.objUser = message);
    if (this.objUser != null && this.objUser != "") {
      alert(this.objUser);
      this.objUser = JSON.parse(this.objUser);
      if (this.objUser != null) {
        let session = this.objUser.lSessionResponse[0];
        //alert(this.objUser);
      }
    }

    let objUser = JSON.parse(sessionStorage.getItem("loginData"));
    let session = objUser.lSessionResponse[0].sessionname;
    alert(sessionStorage.getItem("loginData"));
    this.apiOpenmind.GetActivity(3);
    //this.apiOpenmind.AddModuleWork(1234567, "file:/asasasas/asass", "2", "1", "2");
    const date = new Date();
    var formatedDate = date.getFullYear() + "" + ('0' + (date.getMonth() + 1)).slice(-2) + "" + ('0' + (date.getDate())).slice(-2);
    //this.apiOpenmind.AddModuleWork(new Number(formatedDate).valueOf(), "PRÁCTICAS CAMPUS ACADEMY:/Sesion1/JuanLopez/actividad1.docx", "sdfsdf6fsdf-sdfsdf7-sdfsdf", "sdfsdf6fsdf-sdfsdf7-sdfsdf", "4");
    //this.apiOpenmind.AddResourceTopic(1234567, "sdfsdf6fsdf-sdfsdf7-sdfsdf", "0", "1", "2");
  }

  public incrementCounter() {
    this.currentCount++;
  }
}
